import { z } from "zod";
import { REACTION_TYPE } from "@/lib/sparxs/reactionType";

const reactionTypeSchema = z.enum([
  REACTION_TYPE.THANK_YOU,
  REACTION_TYPE.USEFUL,
  REACTION_TYPE.SURPRISING,
  REACTION_TYPE.INTERESTING,
  REACTION_TYPE.NOT_A_FAN,
]);

const reactionInfoSchema = z.object({
  reactionType: reactionTypeSchema,
  texts: z.array(z.string()),
});

export type SparxReactionInfo = z.infer<typeof reactionInfoSchema>;

const sparxReactionsVersionSchema = z.object({
  version: z.string().min(1),
  reactions: z.array(reactionInfoSchema),
});

export type SparxReactionsVersionCatalog = z.infer<
  typeof sparxReactionsVersionSchema
>;

export const parseSparxReactionsListResponse = (
  raw: unknown,
): SparxReactionsVersionCatalog[] => {
  return z.array(sparxReactionsVersionSchema).parse(raw);
};
